import React from "react";

const JobAnnonce = () => (
  <section
    className="mt-28 max-w-6xl mx-auto my-8 px-4 py-8 bg-white shadow-lg rounded-lg border border-gray-100"
    data-aos="fade-up"
  >
    <header className="mb-8" data-aos="fade-down" data-aos-delay="100">
      <h1 className="text-2xl md:text-3xl font-bold text-[#00df9a] mb-2">
        FICHE DE POSTE
      </h1>
      <h2 className="text-xl font-semibold text-[#00df9a]">
        Chargé(e) Commercial(e) & Marketing Digital{" "}
        <span className="text-sm font-normal text-red-600">
          (CDD Temps Partiel)
        </span>
      </h2>
      <ul className="mt-2 text-gray-700 text-sm md:text-base space-y-1">
        <li>
          <strong>Lieu de travail :</strong> Bangui, République Centrafricaine
        </li>
        <li>
          <strong>Type de contrat :</strong> CDD – Temps partiel (3
          jours/semaine)
        </li>
        <li>
          <strong>Durée :</strong> À définir (renouvelable)
        </li>
        <li>
          <strong>Disponibilité :</strong> À partir du 02/07/2025
        </li>
        <li>
          <strong>Public visé :</strong> Étudiant(e) de préférence (niveau Bac+2
          minimum),{" "}
          <span className="italic">
            la candidature féminine est à encourager
          </span>
        </li>
      </ul>
    </header>

    <section className="mb-6" data-aos="fade-right" data-aos-delay="200">
      <h3 className="text-lg font-semibold text-[#00df9a] mb-2">Missions</h3>
      <ol className="list-decimal list-inside space-y-3 text-gray-800">
        <li>
          <strong>Support administratif pour DecInTech</strong>
          <ul className="list-disc list-inside ml-4 text-gray-700 space-y-1">
            <li>
              Assurer le suivi des tâches administratives courantes (courriers,
              classement, gestion des documents, prise de rendez-vous).
            </li>
            <li>
              Aider à la gestion de la correspondance et des relations avec les
              partenaires locaux.
            </li>
            <li>
              Assister à la préparation de rapports d’activité, de contrats, ou
              de documents administratifs internes.
            </li>
          </ul>
        </li>
        <li>
          <strong>Développement commercial pour Qardyl</strong>
          <ul className="list-disc list-inside ml-4 text-gray-700 space-y-1">
            <li>
              Rechercher activement de nouveaux clients (TPE/PME, indépendants)
              en Centrafrique et en ligne.
            </li>
            <li>
              Présenter et promouvoir les offres de Qardyl auprès de prospects
              par téléphone, email, WhatsApp ou en face-à-face.
            </li>
            <li>
              Gérer et animer un portefeuille clients : relances, suivi des
              demandes, accompagnement à l’inscription et à l’utilisation de la
              plateforme.
            </li>
          </ul>
        </li>
        <li>
          <strong>Marketing digital</strong>
          <ul className="list-disc list-inside ml-4 text-gray-700 space-y-1">
            <li>
              Animer les réseaux sociaux de Qardyl (Facebook, LinkedIn, etc.) :
              création de contenus, publication, modération.
            </li>
            <li>
              Participer à la rédaction de contenus pour le site web, les
              newsletters et les campagnes e-mailing.
            </li>
            <li>
              Suivre les performances des campagnes digitales (reportings
              simples via outils comme Meta Business, Google Analytics…).
            </li>
          </ul>
        </li>
      </ol>
    </section>

    <section className="mb-6" data-aos="fade-left" data-aos-delay="300">
      <h3 className="text-lg font-semibold text-[#00df9a] mb-2">
        Profil recherché
      </h3>
      <ul className="list-disc list-inside text-gray-800 space-y-1">
        <li>
          <strong>Formation :</strong> Etudiant(e) en commerce, communication,
          marketing ou gestion.
        </li>
        <li>
          <strong>Expérience :</strong> Une première expérience en vente,
          marketing ou gestion administrative est un plus.
        </li>
        <li>
          <strong>Compétences :</strong>
          <ul className="list-disc list-inside ml-4 text-gray-700">
            <li>
              Excellente communication écrite et orale (français obligatoire,
              sango un plus).
            </li>
            <li>
              Maîtrise des outils bureautiques (Google Docs, Excel, etc.).
            </li>
            <li>
              Connaissances de base en réseaux sociaux et outils de marketing
              digital.
            </li>
            <li>Sens de l'organisation, autonomie, esprit d’initiative.</li>
          </ul>
        </li>
        <li>
          <strong>Qualités personnelles :</strong> Dynamique, rigoureux(se),
          orienté(e) résultats, à l’aise avec le travail en petite équipe.
        </li>
      </ul>
    </section>

    <section className="mb-6" data-aos="fade-up" data-aos-delay="400">
      <h3 className="text-lg font-semibold text-[#00df9a] mb-2">Conditions</h3>
      <ul className="list-disc list-inside text-gray-800 space-y-1">
        <li>
          <strong>Rémunération :</strong> À discuter selon profil (fixe +
          éventuelles primes sur performance commerciale).
        </li>
        <li>
          <strong>Horaires :</strong> 3 jours par semaine (flexibilité possible
          selon emploi du temps universitaire).
        </li>
        <li>
          <strong>Lieu de travail :</strong> Bangui, Bureau basé au rond-point
          PK0.
        </li>
      </ul>
    </section>

    <section className="mb-6" data-aos="zoom-in" data-aos-delay="500">
      <h3 className="text-lg font-semibold text-[#00df9a] mb-2">
        Comment postuler ?
      </h3>
      <p className="text-gray-800">
        Envoyez votre CV et une courte lettre de motivation à l’adresse:{" "}
        <a
          href="mailto:contact@decintech.com"
          className="text-blue-700 underline"
        >
          contact@decintech.com
        </a>
        ,<br />
        avec en objet{" "}
        <span className="italic">
          "Candidature – Chargé Commercial & Marketing Digital (Bangui)"
        </span>
        .
      </p>
    </section>

    <section data-aos="fade-up" data-aos-delay="600">
      <h3 className="text-lg font-semibold text-[#00df9a] mb-2">
        À propos de nous
      </h3>
      <p className="text-gray-800 mb-2">
        DecInTech est une entreprise technologique basée à Bangui, en République
        Centrafricaine, spécialisée dans le numérique, la collecte et l’analyse
        de données, ainsi que le développement de solutions logicielles sur
        mesure. Nous accompagnons les entreprises et organisations dans leur
        transformation digitale, en leur fournissant des outils innovants pour
        optimiser leurs processus et valoriser leurs données.
      </p>
      <p className="text-gray-800 mb-2">
        Parmi nos réalisations figure{" "}
        <a href="https://www.qardyl.com/" className="text-[#00df9a] underline">
          Qardyl
        </a>
        , la carte de visite digitale, sans contact et connectée. Qardyl
        illustre notre engagement à proposer des solutions simples, accessibles
        et efficaces pour répondre aux besoins concrets du tissu économique
        local.
      </p>
      <p className="text-gray-800 mb-2">
        <strong>Notre mission :</strong> transformer vos données en leviers de
        performance. Grâce à des techniques avancées d’analyse, une connaissance
        fine des enjeux métiers et une approche centrée sur l’utilisateur, nous
        concevons des solutions agiles, robustes et personnalisées, parfaitement
        alignées sur les objectifs de chaque client.
      </p>
      <p className="text-gray-800 mb-2">
        Au-delà de l’analyse de données, nous offrons des services de
        développement d’applications web et mobiles adaptées aux exigences de
        votre secteur. Notre méthode de travail itérative nous permet de livrer
        rapidement des résultats concrets tout en assurant qualité et
        évolutivité.
      </p>
      <p className="text-gray-800">
        Chez DecInTech, l’innovation est au cœur de notre démarche.
        <br />
        <span className="font-semibold">En savoir plus :</span>
        <br />
        <a
          href="https://www.decintech.com/"
          className="text-[#00df9a] underline"
        >
          www.decintech.com
        </a>{" "}
        |{" "}
        <a href="https://www.qardyl.com/" className="text-[#00df9a] underline">
          www.qardyl.com
        </a>
      </p>
    </section>
  </section>
);

export default JobAnnonce;
